import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';
import storageMiddleware from './middlewares/storage.middleware';
import routingMiddleware from './middlewares/routing.middleware';
import heartbeatMiddleware from './middlewares/heartbeat.middleware';
import analyticsMiddleware from './middlewares/analytics.middleware';
import navigationMiddleware from './middlewares/navigation.middleware';

const composeEnhancers =
  process.env.NODE_ENV === 'development' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const middlewares = [
  thunk,
  storageMiddleware,
  routingMiddleware,
  navigationMiddleware,
  heartbeatMiddleware,
  analyticsMiddleware,
].filter(Boolean);

export const initStore = () =>
  createStore(combineReducers(reducers), composeEnhancers(applyMiddleware(...middlewares)));
